"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CSCPNIComponent = void 0;
const core_1 = require("@angular/core");
const ng_bootstrap_1 = require("@ng-bootstrap/ng-bootstrap");
const account_service_1 = require("./../services/account.service");
const cpni_service_1 = require("../services/cpni.service");
const generic_content_service_1 = require("../services/generic.content.service");
const roles_helper_service_1 = require("../services/roles-helper.service");
const constants_1 = require("../constants");
class CSCPNIComponent {
    constructor(modalService, genericContentService, accountService, cpniService, rolesService) {
        this.modalService = modalService;
        this.genericContentService = genericContentService;
        this.accountService = accountService;
        this.cpniService = cpniService;
        this.rolesService = rolesService;
        this.roles = constants_1.UserRole;
        this.callAjax = new core_1.EventEmitter();
        this.closedAfterEmailSent = new core_1.EventEmitter();
    }
    open(content) {
        this.modelRef = this.modalService.open(content, { windowClass: 'dark-modal' });
        this.errorMsg = '';
        this.cpin = null;
        // this.isCpinRequired(true);
        this.modelRef.closed.subscribe(() => {
            if (this.cpniEmailSent) {
                this.closedAfterEmailSent.emit();
            }
        });
    }
    ngOnInit() {
        this.getErrorMessage();
        this.cpniEmailSent = false;
    }
    verifyEmailStatus() {
        this.accountService.getEmailFlagStatus().subscribe((data) => {
            this.isEmailVerify = data;
            this.open(this.cpniModelContent);
        }, (err) => {
            this.error = err;
            this.isEmailVerify = false;
        });
    }
    getCPINContent() {
        this.loading = true;
        this.genericContentService.getGenericContent('/generic/disclaimer/cpniInformation')
            .subscribe((content) => {
            this.cpniInformationContent = content;
            this.loading = false;
        }, (err) => {
            this.modelError = err;
            this.loading = false;
        });
    }
    isCpinRequired() {
        this.cpniService.cpinCheck()
            .subscribe((res) => {
            this.check = res;
            if (this.check.cpniRequired) {
                this.verifyEmailStatus();
            }
            else {
                this.callAjax.emit(true);
            }
            // this.resetPin();
        }, (err) => {
            this.modelError = err;
            this.loading = false;
        });
    }
    resetPin(ssn) {
        this.loading = true;
        // reset error messages
        this.modelError = null;
        this.error = null;
        this.errorMsg = null;
        this.feErrorMsg = null;
        // ask for new cpni generation
        this.cpniService.createPin()
            .subscribe((res) => {
            this.created = res;
            if (res.verificationEmailSent !== undefined) {
                this.cpniEmailSent = res.verificationEmailSent;
            }
            this.loading = false;
        }, (err) => {
            this.modelError = err;
            this.loading = false;
        });
    }
    triggerAction() {
        this.modelError = null;
        this.isCpinRequired();
    }
    validatePin(value) {
        this.loading = true;
        this.cpniService.validate(value)
            .subscribe((res) => {
            this.validation = res;
            this.loading = false;
            if (res.error !== undefined) {
                this.errorMsg = res.error;
            }
            else {
                this.callAjax.emit(true);
                this.errorMsg = '';
                this.modelRef.close();
            }
        }, (err) => {
            this.modelError = err;
            this.loading = false;
        });
    }
    getErrorMessage() {
        this.loader = true;
        this.accountService.getCSErrorMessage().subscribe((res) => {
            this.loader = false;
            this.feErrorMsg = res;
        }, (err) => {
            this.error = err;
            this.loader = false;
        });
    }
    inputOnlyNumber(event) {
        return (event.charCode === 8 || event.charCode === 0) ? null : event.charCode >= 48 && event.charCode <= 57;
    }
    navigate() {
        if (this.accountType === 'BUSINESS') {
            location.href = '/my_account/personal/#/business/account-settings';
        }
        else if (this.accountType === 'CONSUMER_POSTPAID') {
            location.href = '/my_account/personal/#/wireless/account-settings';
        }
        else if (this.accountType === 'CONSUMER_PREPAID') {
            location.href = '/my_account/personal/#/prepaid/account-settings';
        }
        this.modelRef.close();
    }
    showRoles(roles) {
        return this.rolesService.getRolesPermission(roles);
    }
}
exports.CSCPNIComponent = CSCPNIComponent;
//# sourceMappingURL=cpni.component.js.map